import React from 'react';

import ModalContext from './modalContext';
import useModalProvider from './useModalProvider';

interface IModalProviderProps {
	children: any;
}

const ModalProvider: React.FC<IModalProviderProps> = ({ children }) => {
	const { modalConfig, setModalConfig } = useModalProvider();

	return <ModalContext.Provider value={{ modalConfig, setModalConfig }}>{children}</ModalContext.Provider>;
};

export default ModalProvider;
